/**
 * Sensei Pro flashcards: click the card face to flip.
 */
document.addEventListener('click', (event) => {
	const target = event.target;
	if (!(target instanceof Element)) {
		return;
	}

	const flip = target.closest('.sensei-lms-flip');
	if (!flip) {
		return;
	}

	if (target.closest('.sensei-lms-flip__button')) {
		return;
	}

	if (target.closest('a, button, input, textarea, select')) {
		return;
	}

	flip.querySelector('.sensei-lms-flip__button')?.click();
});
